// Bridge Livewire components to the Repora beacon: actions that finish
// without a navigation dispatch a browser event instead of flashing the
// session. window.beacon may be absent (script loading, or blocked).
window.addEventListener('analytics:track', (event) => {
    const { name, category, label } = event.detail ?? {};

    if (name) {
        window.beacon?.track(name, { category, label });
    }
});
